import React from "react";
import MainBanner from "../../components/MainComponents/MainBanner";
import ConsultationBookingSection from "../../components/HomeComponents/ConsultationBookingSection";
import MeetOurExperts from "../../components/MainComponents/MeetOurExperts";
import FeatureSection from "../../components/HomeComponents/FeatureSection";
import HealingStories from "../../components/HomeComponents/HealingStories";
import AreasWeServe from "../../components/MainComponents/AreasWeServe";
import Footer from "../../components/MainComponents/Footer";
import ServicesSection from "../../components/MainComponents/ServicesSection";
import { mainTitle } from "../../config";
import BookAppointmentSection from "../../components/HomeComponents/BookAppointmentSection";
import WellnessSection from "../../components/HomeComponents/HealthWellnessSection";
import InsurancePartners from "../../components/HomeComponents/InsurancePartners";
import CallToActionSection from "../../components/MainComponents/CallToAction";
import FAQSection from "../../components/PatientComponents/FAQ";
import AppointmentSection from "../../components/ServiceComponents/AppointmentSection";
import OurSpecialities from "../../components/HomeComponents/OurSpecialitiesSection";
import ContactHeader from "../../components/MainComponents/ContactHeader";


const HomePage = () => {
  return (
    <div>
      {/* <Header /> */}
      <ContactHeader/>
      <MainBanner
        bannerTitle={mainTitle}
        banenrHeadline={"Live a healthy and happy life free from pain!"}
        bannerDescription={
          "Combining physiotherapy with the latest research and technology to deliver life long results"
        }
      />

      {/* <ConsultationBookingSection /> */}
      <BookAppointmentSection/>
      <ServicesSection />
      
      <WellnessSection/>
      <OurSpecialities/>
      {/* <MeetOurExperts /> */}
      <FeatureSection />
      {/* <InsurancePartners/> */}
      {/* <HealingStories /> */}
     
      <AppointmentSection/>
      <FAQSection/>
      <AreasWeServe />
      <CallToActionSection/>
      <Footer />
    </div>
  );
};

export default HomePage;
